import { render, staticRenderFns } from "./Capsule.vue?vue&type=template&id=6c015dd3"
import script from "./Capsule.vue?vue&type=script&lang=js"
export * from "./Capsule.vue?vue&type=script&lang=js"
import style0 from "./Capsule.vue?vue&type=style&index=0&id=6c015dd3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.97.1__lodash@4.17.21__o37vjc56bbn3qeic3ehqykr2mu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports